import Case, { SizeText } from '../Case';
import { CaseFormat as CaseFormatI } from '../../models/common';
import styles from './CaseContainer.module.scss';

export type Props = {
  data: CaseFormatI[];
};

const CaseContainer = (props: Props): JSX.Element => {
  const { data } = props;

  return (
    <div className={styles.caseContainer}>
      <div className={styles.container}>
        {data.map((element, idx) => {
          return (
            <div key={idx}>
              <Case
                title={element?.title}
                link={element?.link}
                titleTextSize={SizeText.MEDIUM}
                size="small"
                image={{ ...element.image, width: 640, height: 682 }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default CaseContainer;
